import { ICustomConfig, RouterLinkComponentType } from '@/ui';
import { generateTheme } from '../styles/theme';
import { dateTimeFormat } from '../i18n/dateTimeFormat';
import { RouterLink } from '../components/common/link/RouterLink';
import { useNavigate } from '../navigation/useNavigate';
import { SiteSectionSlug } from '../features/app/pages/domain/constants/siteSectionSlug';

export function getUiConfig(currentWebsite: SiteSectionSlug): ICustomConfig {
	const theme = generateTheme(currentWebsite);

	return {
		theme,
		dateTimeFormat,
		RouterLinkComponent: RouterLink as RouterLinkComponentType,
		useNavigate,
	};
}
